import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { HERO_IMG } from "../lib/site";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.19, 1, 0.22, 1], delay: i * 0.12 } }),
};

const chapters = [
  { n: "01", t: "Notary Brought To You", d: "Home, office, hospital or cafe — I meet you wherever is most convenient." },
  { n: "02", t: "Precision & Confidence", d: "Every signature, seal and detail handled with meticulous, courteous care." },
  { n: "03", t: "Confidential By Nature", d: "Your documents and personal information are always kept private and secure." },
];

const ribbon = ["Mobile Notary", "Power of Attorney", "Real Estate", "Affidavits", "Business Documents", "Loan Signing", "Hospital Visits"];

export const About = () => {
  return (
    <section id="about" className="relative bg-ivory py-24 lg:py-32 overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Image */}
          <motion.div
            className="lg:col-span-5 relative"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="relative p-3 border border-gold/40 rounded-[1.4rem]">
              <div className="rounded-2xl overflow-hidden h-[26rem]">
                <img src={HERO_IMG} alt="Gold pen resting on notarized legal document" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="absolute -bottom-6 right-6 bg-ink text-ivory rounded-2xl px-6 py-4 shadow-xl">
              <div className="font-serif text-gold text-3xl leading-none">100%</div>
              <div className="eyebrow text-taupe text-[9px] mt-1">Client Focused</div>
            </div>
          </motion.div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <motion.p className="eyebrow text-goldDark mb-4" variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}>
              About Me
            </motion.p>
            <motion.h2
              className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight"
              variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
            >
              Welcome to <span className="gold-text italic">MB Notary Services</span>
            </motion.h2>
            <span className="block w-16 h-px bg-gold mt-6 mb-6" />
            <motion.p
              className="text-ink/75 font-light leading-relaxed max-w-xl"
              variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
            >
              I provide professional, reliable mobile notary services throughout the Chicagoland
              area. Whether you need a single document notarized or multiple signatures completed,
              I bring the notary directly to you with prompt, courteous, and confidential service.
              My goal is to make notarization simple, convenient, and stress-free while delivering
              a luxury client experience.
            </motion.p>

            <motion.p
              className="font-serif italic text-3xl gold-text mt-8"
              variants={fadeUp} custom={3} initial="hidden" whileInView="show" viewport={{ once: true }}
            >
              Miranda Baggett
            </motion.p>
            <p className="eyebrow text-taupe mt-1">Illinois Notary Public</p>

            <div className="mt-10 grid sm:grid-cols-3 gap-6">
              {chapters.map((c, i) => (
                <motion.div
                  key={c.n}
                  variants={fadeUp} custom={i + 4} initial="hidden" whileInView="show" viewport={{ once: true }}
                  className="group"
                >
                  <div className="font-serif gold-text text-2xl">{c.n}</div>
                  <div className="hairline my-3" />
                  <h3 className="font-serif text-lg mb-1">{c.t}</h3>
                  <p className="text-ink/60 text-sm font-light leading-relaxed">{c.d}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Editorial ribbon */}
      <div className="mt-20 border-y border-gold/25 py-6 bg-ink">
        <Marquee speed={40} gradient={false} autoFill>
          {ribbon.map((r, i) => (
            <div key={i} className="flex items-center">
              <span className="font-serif italic text-ivory/80 text-2xl sm:text-3xl px-8">{r}</span>
              <span className="text-gold text-xl">&#10022;</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default About;
